module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/aa1a855db1cacd5d7dd2196ab27594f6.png";